
import { DefineCommand } from '../../../concepts/commands/CommandDefinition';
import { CommandDispatcher } from '../../../concepts/commands/CommandDispatcher';
import { inCommands } from '../../../concepts/commands/CommandRegistry';
import { ObjectManager } from '../../../concepts/objects';
import { resolveSubjects } from '../../canvas/commands/CommandUtil';
import { place } from '../../canvas/commands/OrderCommands';
import { select } from '../../canvas/commands/SelectionCommands';
import { EditorSession } from '../../canvas/EditorSession';
import { Phys } from '../../canvas/entities/Phys';
import { Physical, RelativeTo } from '../../canvas/entities/Physical';
import { RootOverride } from '../../canvas/RootOverride';
import { Selection } from '../../canvas/Selection';
import { Graphic } from '../graphics/Graphic';
import { Symbol } from './Symbol';

export const createSymbol = DefineCommand({
    name: 'createSymbol',
    ui: {
        context: {
            label: 'Convert to Symbol',
            when: r => r.call(EditorSession).get(Selection).uniform(Graphic),
        },
    },
    impl(cc, [targetIds]: [string[]?]) {

        const dispatch = cc.call(CommandDispatcher);
        const objects = cc.call(ObjectManager);

        const items = Phys.from(resolveSubjects(cc, targetIds)).polarize(Graphic).takeHeads();
        if (!items.size) return;

        objects.update(u => {

            const ids = items.map(tm => {

                const bounds = tm.bounds(RelativeTo.Model);
                const symbol = u.create(Symbol);

                symbol.moveTo(bounds.topLeft());
                symbol.resize(bounds.width, bounds.height);

                objects.getRoot().add(symbol);

                const f = tm.createFigure();
                symbol.add(tm.removeSelf());
                tm.setFromFigure(f);

                return symbol.id;
            });

            dispatch(place, [ids]);
            dispatch(select, [ids]);
        });
    }
});

export const destroySymbol = DefineCommand({
    name: 'destroySymbol',
    ui: {
        context: {
            label: 'Destroy Symbol',
            when: r => r.call(EditorSession).get(Selection).uniform(Symbol),
        },
    },
    impl(cc, [targetIds]: [string[]?]) {

        const dispatch = cc.call(CommandDispatcher);
        const objects = cc.call(ObjectManager);
        const session = cc.call(EditorSession);

        const root = session.get(RootOverride) ?? objects.getRoot();
        const items = Phys.from(resolveSubjects(cc, targetIds)).polarize(Symbol).takeHeads();
        if (!items.size) return;

        objects.update(u => {

            const ids = items.flatMap(tm => {

                const children = tm.polarize(Physical);

                for (const ch of children) {
                    const f = ch.createFigure();
                    root.add(ch.removeSelf());
                    ch.setFromFigure(f);
                }

                u.delete(tm.removeSelf(), 'cascade');

                return children.map(x => x.id);
            });

            dispatch(place, [ids]);
            dispatch(select, [ids]);
        });
    }
});

export const inSymbolCommands = () => inCommands(
    createSymbol,
    destroySymbol,
);

